module.exports = __webpack_public_path__ + "img/amscoin.f4b0c39e.png";